import { graphql } from "msw";
import countries from "../data/oms/countries";

export const handlers = [
  graphql.query("getCountries", (req, res, ctx) => {
    return res(
      ctx.data({
        getCountries: countries,
      })
    );
  }),
];
